import React, { useState } from "react";
import * as RB from "react-bootstrap";
import axios from "axios"; // ✅ for delete API call
import Swal from "sweetalert2";
import { callAPI } from "../../Utils/comman";

function FileUpload({ setFiles, file, editFile, setEditfile }) {
  const [isDraggingOver, setIsDraggingOver] = useState(false);
  const [isInvalidFile, setIsInvalidFile] = useState(false);

  // ✅ Supported types
  const validTypes = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  ];

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDraggingOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDraggingOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDraggingOver(false);

    const droppedFiles = Array.from(e.dataTransfer.files);
    const isValidFileType = droppedFiles.every((f) =>
      validTypes.includes(f.type)
    );

    if (!isValidFileType) {
      setIsInvalidFile(true);
      return;
    } else {
      setIsInvalidFile(false);
    }

    setFiles((prev) => [...prev, ...droppedFiles]);
  };

  const handleFileChange = (e) => {
    const uploadedFiles = Array.from(e.target.files);
    const isValidFileType = uploadedFiles.every((f) =>
      validTypes.includes(f.type)
    );

    if (!isValidFileType) {
      setIsInvalidFile(true);
      return;
    } else {
      setIsInvalidFile(false);
    }

    setFiles((prev) => [...prev, ...uploadedFiles]);
  };

  // ✅ Delete handler
  const handleDeleteFile = async (index, f) => {
    // Case 1: File came from API (has id + attachPath)
    if (f?.id) {
      try {
        await axios.post("/meeting/branding/delete", { id: f.id }); // adjust API path
        const updatedFiles = [...file];
        updatedFiles.splice(index, 1);
        setFiles(updatedFiles);
      } catch (err) {
      }
    } else {
      // Case 2: File is newly uploaded
      const updatedFiles = [...file];
      updatedFiles.splice(index, 1);
      setFiles(updatedFiles);
    }
  };

  // ✅ Detect file type for preview
  const getFilePreview = (f) => {
    // Case 1: Newly uploaded file
    if (f instanceof File) {
      if (f.type.startsWith("image/")) {
        return (
          <img
            src={URL.createObjectURL(f)}
            alt={f.name}
            className="img-fluid rounded"
            style={{ maxHeight: "100px", objectFit: "cover" }}
          />
        );
      } else if (f.type === "application/pdf") {
        return (
          <i className="material-icons-outlined md-64 text-danger">
            picture_as_pdf
          </i>
        );
      } else if (f.type.includes("word")) {
        return (
          <i className="material-icons-outlined md-64 text-primary">
            description
          </i>
        );
      } else if (f.type.includes("excel")) {
        return (
          <i className="material-icons-outlined md-64 text-success">
            table_chart
          </i>
        );
      } else if (f.type.includes("presentation")) {
        return (
          <i className="material-icons-outlined md-64 text-warning">
            slideshow
          </i>
        );
      }
    }

    // Case 2: File from API (string path)
    if (f?.attachPath) {
      if (f.branding_image.match(/\.(jpg|jpeg|png|gif)$/i)) {
        return (
          <img
            src={f.attachPath}
            alt={f.branding_image}
            className="img-fluid rounded"
            style={{ maxHeight: "100px", objectFit: "cover" }}
          />
        );
      } else if (f.branding_image.endsWith(".pdf")) {
        return (
          <i className="material-icons-outlined md-64 text-danger">
            picture_as_pdf
          </i>
        );
      } else if (
        f.branding_image.endsWith(".doc") ||
        f.branding_image.endsWith(".docx")
      ) {
        return (
          <i className="material-icons-outlined md-64 text-primary">
            description
          </i>
        );
      } else if (
        f.branding_image.endsWith(".xls") ||
        f.branding_image.endsWith(".xlsx")
      ) {
        return (
          <i className="material-icons-outlined md-64 text-success">
            table_chart
          </i>
        );
      } else if (
        f.branding_image.endsWith(".ppt") ||
        f.branding_image.endsWith(".pptx")
      ) {
        return (
          <i className="material-icons-outlined md-64 text-warning">
            slideshow
          </i>
        );
      }
    }

    return (
      <i className="material-icons-outlined md-64 text-secondary">
        insert_drive_file
      </i>
    );
  };

  const handleDeleteApiFile = (file) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        callAPI("get", `meeting/branding/document-delete?id=${file?.id}`, "")
          .then((res) => {
            if (typeof res !== "undefined") {
              // ✅ Instead of fetching again, update local state
              setEditfile((prev) =>
                prev.map((f) =>
                  f.id === file.id ? { ...f, isDeleted: true } : f
                )
              );
              // Swal.fire("Deleted!", "Your file has been removed.", "success");
            }
          })
          .catch((err) => {
            // Swal.fire("Error!", "Failed to delete file.", "error");
          });
      }
    });
  };

  return (
    <RB.Card className="mt-4">
      <RB.CardBody className="p-2">
        <h6 className="mb-2">Upload Files</h6>
        <hr />
        <div
          className={`border p-4 text-center d-flex flex-column align-items-center ${
            isDraggingOver ? "bg-info" : ""
          }`}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          <div className="avatar avatar-circle avatar-lg bg-light text-dark">
            <i className="material-icons-outlined">cloud_upload</i>
          </div>
          <p className="mb-0">Drag & Drop files here</p>
          <small className="mb-2">or</small>
          <div>
            <input
              type="file"
              accept={validTypes.join(",")}
              multiple
              style={{ display: "none" }}
              onChange={handleFileChange}
              id="fileInput"
            />
            <RB.Button
              variant="primary"
              className="me-2"
              onClick={() => document.getElementById("fileInput").click()}
            >
              <i className="las la-file-upload me-1"></i>Browse Files
            </RB.Button>
          </div>
        </div>
        <span className={`${isInvalidFile ? "text-danger" : ""}`}>
          <small>
            *Note: Only Images, PDF, Word, Excel, PPT files are allowed
          </small>
        </span>

        {/* ✅ File Preview Grid */}
        <RB.Row className="mt-3 g-3">
          {/* ✅ Render new uploaded files */}
          {file.map((f, index) => (
            <RB.Col key={`new-${index}`} className="col-md-6 col-lg-4">
              <div className="position-relative me-2 mb-4 rounded border p-3 text-center">
                <div className="product-doc-upload">
                  <a
                    href={URL.createObjectURL(f)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-none text-dark"
                  >
                    {getFilePreview(f)}
                    <div className="text-truncate mt-2">{f.name}</div>
                  </a>
                </div>
                <RB.Button
                  variant="danger"
                  className="btn btn-sm btn-circle position-absolute top-100 start-50 translate-middle"
                  onClick={() => handleDeleteFile(index, f)} // removes from file[]
                >
                  <i className="material-icons-outlined">delete</i>
                </RB.Button>
              </div>
            </RB.Col>
          ))}
          {editFile
            ?.filter((f) => !f.isDeleted) // hide deleted
            .map((f, index) => (
              <RB.Col key={`api-${index}`} className="col-md-6 col-lg-4">
                <div className="position-relative me-2 mb-4 rounded border p-3 text-center">
                  <div className="product-doc-upload">
                    <a
                      href={f.attachPath}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-none text-dark"
                    >
                      <img
                        src={f.attachPath}
                        alt={f.branding_image}
                        className="img-fluid rounded"
                        style={{ maxHeight: "100px", objectFit: "cover" }}
                      />
                      <div className="text-truncate mt-2">
                        {f.branding_image}
                      </div>
                    </a>
                  </div>
                  <RB.Button
                    variant="danger"
                    className="btn btn-sm btn-circle position-absolute top-100 start-50 translate-middle"
                    onClick={() => handleDeleteApiFile(f)} // soft delete
                  >
                    <i className="material-icons-outlined">delete</i>
                  </RB.Button>
                </div>
              </RB.Col>
            ))}
        </RB.Row>
      </RB.CardBody>
    </RB.Card>
  );
}

export default FileUpload;
